// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item:has(.sub-item:hover)>.item-header{background:var(--color-primary-300)!important;color:var(--color-primary-900)!important}.item:has(.sub-item:hover)>.item-header .item-icon{color:var(--color-primary-900)!important}.item:has(.sub-item:hover)>.item-header .item-expand-chevron{color:var(--color-primary-900)!important}", ""]);
// Exports
module.exports = exports;
